module.exports = __webpack_public_path__ + "media/images/app/visitors/bridal/diamond_bracelets-bb3487ba5a35e7ca48a72846c7ec97f1.webp";